import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form/immutable'
import { removeSymbolsFromPhone } from 'helpers/parsePhone'

import InputPhoneNumber from './InputPhoneNumber'
import i18next from 'i18next'

const getFieldName = prefixForField => (prefixForField ? `${prefixForField}phoneISO` : 'phoneISO')

export const phoneMinLength = min => phone => {
  if (!phone) {
    return undefined
  }
  const phoneWithoutPhoneCode = removeSymbolsFromPhone(phone)
  const isInvalidPhone =
    (phone.length && !phoneWithoutPhoneCode.length) || (phoneWithoutPhoneCode && phoneWithoutPhoneCode.length < min)
  return isInvalidPhone ? i18next.t('Min characters allowed', { min }) : undefined
}

export const phoneMaxLength = max => phone => {
  if (!phone) {
    return undefined
  }
  const phoneWithoutPhoneCode = removeSymbolsFromPhone(phone)
  const isInvalidPhone =
    (phone.length && !phoneWithoutPhoneCode.length) || (phoneWithoutPhoneCode && phoneWithoutPhoneCode.length > max)
  return isInvalidPhone ? i18next.t('Max characters allowed', { max }) : undefined
}

const mapStateToProps = (state, ownProps) => ({
  selectedISO: formValueSelector(ownProps.form)(state, getFieldName(ownProps.prefixForField)),
})

export default connect(mapStateToProps)(InputPhoneNumber)
